/** @format */

import { push } from 'connected-react-router';
import { declinePostOnboardedBrokerApiService } from 'services/apiService';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as actionTypes from 'stateContainer/action-types';

function* workerSaga({ payload }) {
  try {
    const response = yield call(declinePostOnboardedBrokerApiService, payload);
    if (response.data.status == 'success') {
      /**
       * finally conclude the login action
       */

      yield put({
        type: actionTypes.DECLINE_POST_ONBOARDED_BROKER_SUCCESS,
        data: response.data.data
      });
    } else {
      throw new Error('Decline broker failed');
    }
  } catch (error) {
    if (error.response.data.error == 'NotAuthorized') {
      yield put(push({ type: actionTypes.LOGOUT_REQUESTED }));
      yield put(push('/login'));
    }
    yield put({
      type: actionTypes.DECLINE_POST_ONBOARDED_BROKER_FAILED,
      error
    });
  }
}

export function* declinePostOnboardedBrokerSaga() {
  yield takeLatest(
    actionTypes.DECLINE_POST_ONBOARDED_BROKER_REQUESTED,
    workerSaga
  );
}
